var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsHeaderIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 79,
    viewBox: "0 0 187 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 35.375C8.14 35.375 1.375 42.14 1.375 50.5C1.375 58.86 8.14 65.625 16.5 65.625C24.86 65.625 31.625 58.86 31.625 50.5C31.625 42.14 24.86 35.375 16.5 35.375ZM16.5 62.875C9.66625 62.875 4.125 57.3337 4.125 50.5C4.125 43.6663 9.66625 38.125 16.5 38.125C23.3337 38.125 28.875 43.6663 28.875 50.5C28.875 57.3337 23.3337 62.875 16.5 62.875Z",
    fill: "#DEDEDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 51.875C17.2562 51.875 17.875 51.2562 17.875 50.5V45C17.875 44.2437 17.2562 43.625 16.5 43.625C15.7437 43.625 15.125 44.2437 15.125 45V50.5C15.125 51.2562 15.7437 51.875 16.5 51.875Z",
    fill: "#DEDEDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5138 54.625H16.5C15.7437 54.625 15.125 55.2438 15.125 56C15.125 56.7563 15.7437 57.375 16.5 57.375H16.5138C17.27 57.375 17.8888 56.7563 17.8888 56C17.8888 55.23 17.27 54.625 16.5138 54.625Z",
    fill: "#DEDEDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.5 27.875H154.5C151.819 27.875 149.625 30.0688 149.625 32.75V52.25C149.625 54.9312 151.819 57.125 154.5 57.125H180.5C183.181 57.125 185.375 54.9312 185.375 52.25V32.75C185.375 30.0688 183.181 27.875 180.5 27.875ZM154.5 31.125H180.5C181.134 31.125 181.67 31.4987 181.946 32.035L167.5 42.1425L153.054 32.035C153.33 31.4987 153.866 31.125 154.5 31.125ZM180.5 53.875H154.5C153.606 53.875 152.875 53.1437 152.875 52.25V35.87L166.574 45.4575C167.126 45.8475 167.874 45.8475 168.443 45.4575L182.141 35.87V52.25C182.125 53.1437 181.394 53.875 180.5 53.875Z",
    fill: "#DEDEDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 27C60.5 26.175 59.825 25.5 59 25.5L44 25.5C43.175 25.5 42.5 26.175 42.5 27C42.5 27.825 43.175 28.5 44 28.5L59 28.5C59.84 28.5 60.5 27.825 60.5 27Z",
    fill: "#DEDEDE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 18C69.5 17.175 68.825 16.5 68 16.5L44 16.5C43.175 16.5 42.5 17.175 42.5 18C42.5 18.825 43.175 19.5 44 19.5L68 19.5C68.84 19.5 69.5 18.825 69.5 18Z",
    fill: "#DEDEDE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 9C54.5 8.175 53.825 7.5 53 7.5L44 7.5C43.175 7.5 42.5 8.175 42.5 9C42.5 9.825 43.175 10.5 44 10.5L53 10.5C53.84 10.5 54.5 9.825 54.5 9Z",
    fill: "#DEDEDE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3555 71.2969C87.3555 71.3221 87.3555 71.3221 87.3555 71.3474C87.3555 75.3131 90.5634 78.521 94.5291 78.521C98.4948 78.521 101.703 75.3131 101.703 71.3474C101.703 71.3221 101.703 71.3221 101.703 71.2969H87.3555Z",
    fill: "#007AFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.437 62.3299L110.971 52.8324C110.971 49.9276 110.971 42.8298 110.971 40.9859C110.971 33.004 105.288 26.3355 97.7353 24.8452V21.2332C97.7353 19.4398 96.2955 18 94.5021 18C92.7087 18 91.2689 19.4398 91.2689 21.2332V24.8705C83.7164 26.3608 78.0331 33.0292 78.0331 41.0111C78.0331 44.1433 78.0331 51.039 78.0331 52.8577L71.5667 62.3551C70.8847 63.3655 70.809 64.6537 71.39 65.7146C71.9457 66.7755 73.057 67.4575 74.2695 67.4575H114.709C115.922 67.4575 117.033 66.8007 117.589 65.7146C118.195 64.6284 118.119 63.3402 117.437 62.3299Z",
    fill: "#007AFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 33.5,
    r: 11.5,
    fill: "#FFB275"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsHeaderIcons);
export default __webpack_public_path__ + "static/media/notifications-header-icons.1b8bfc9fcb544786cd1e6153417f72c3.svg";
export { ForwardRef as ReactComponent };